import api from './config';

// Get all press releases (admin)
export const getPressReleases = async (params = {}) => {
  try {
    const response = await api.get('/press-releases', { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get active press releases (public)
export const getActivePressReleases = async () => {
  try {
    const response = await api.get('/press-releases/active');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get single press release
export const getPressRelease = async (id) => {
  try {
    const response = await api.get(`/press-releases/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Create new press release
export const createPressRelease = async (formData) => {
  try {
    const response = await api.post('/press-releases', formData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Update press release
export const updatePressRelease = async (id, formData) => {
  try {
    const response = await api.put(`/press-releases/${id}`, formData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Delete press release
export const deletePressRelease = async (id) => {
  try {
    const response = await api.delete(`/press-releases/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Toggle press release active status
export const togglePressReleaseStatus = async (id) => {
  try {
    const response = await api.patch(`/press-releases/${id}/status`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get press release statistics
export const getPressReleaseStats = async () => {
  try {
    const response = await api.get('/press-releases/stats');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
